import axios from "./axios";

/**
 * Fetch case counts grouped by tag (for statistics overview).
 */
export async function fetchCaseStatsByTag() {
  return axios
    .get("/cases/stats_by_tag")
    .then((res) => res?.data?.data ?? res?.data ?? { cases_by_tag: [] })
    .catch(() => ({ cases_by_tag: [] }));
}
